module.exports = __webpack_public_path__ + "media/college_jobs_internships/jobs_promo02-3e3d9470.png";